module.exports = __webpack_public_path__ + "static/docs/Vermietungsplaene_Tuefwis_Keller_Haus_B_200115.045c9399.pdf";